export default __webpack_public_path__ + "images/referrals-onboarding-step-4_2x.9eadb2ce19461bea7305b80106417695.png";